export interface FlashLogStatus {
  autoRetry1Failed: number | null;
  autoRetry2Failed: number | null;
  downloadedNoResponse: number | null;
  downloadedSuccessfully: number | null;
  flashFailed: number | null;
  flashedSuccessfully: number | null;
  initialDownloadFailed: number | null;
  queued: number | null;
  reportDate: string | null;
  staleFilesRemoved: number | null;
}

export type FlashLogStatuses = { flashLogStatuses: FlashLogStatus[] };

export enum flashLogActionNames {
  SET_FLASH_LOG_SUMMARIES = 'SET_FLASH_LOG_SUMMARIES',
  SET_IS_LOADING = 'SET_IS_LOADING',
}

export interface FlashLogState {
  flashLogs: undefined | FlashLogStatus[];
  isLoading: boolean | undefined;
}

interface SetFlashLogAction {
  type: typeof flashLogActionNames.SET_FLASH_LOG_SUMMARIES;
  payload: FlashLogStatus[];
}

interface SetFlashLogLoading {
  type: typeof flashLogActionNames.SET_IS_LOADING;
  payload: boolean;
}

export type FlashLogActionTypes = SetFlashLogAction | SetFlashLogLoading;
